import React, { useEffect, createElement } from 'react';
import { motion } from 'framer-motion';
import { CountdownTimer } from './CountdownTimer';
import { SocialProofPopup } from './SocialProofPopup';
import { Testimonials } from './Testimonials';
import { ShieldCheckIcon, CheckCircle2Icon, XCircleIcon, ArrowRightIcon, ZapIcon } from 'lucide-react';
const CHECKOUT_URL = 'https://checkout.impulsodigitalx.shop/cart/45790415061153:1';
export function SalesPage() {
  // Inject Meta Pixel
  useEffect(() => {
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '1900409287233561');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    const noscript = document.createElement('noscript');
    noscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=1900409287233561&ev=PageView&noscript=1" />`;
    document.head.appendChild(noscript);
    return () => {
      // Cleanup if needed, though usually kept for the session
    };
  }, []);
  const handleCheckoutClick = () => {
    window.location.href = CHECKOUT_URL;
  };
  const CtaButton = ({
    text,
    className = '',
    secondary = false
  }: {
    text: string;
    className?: string;
    secondary?: boolean;
  }) => <motion.button onClick={handleCheckoutClick} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`
        w-full max-w-2xl mx-auto block py-5 px-8 rounded-xl font-black text-xl md:text-2xl 
        shadow-[0_8px_30px_rgb(0,0,0,0.12)] transition-all duration-300 flex items-center justify-center gap-3
        ${secondary ? 'bg-green-500 hover:bg-green-600 text-white shadow-green-500/30' : 'bg-yellow-400 hover:bg-yellow-500 text-black shadow-yellow-400/40 animate-pulse-slow'}
        ${className}
      `} data-id="element-2">
      {text}
      <ArrowRightIcon className="w-6 h-6 md:w-8 md:h-8" data-id="element-3" />
    </motion.button>;
  return <div className="min-h-screen bg-white font-sans text-gray-900 pb-20 selection:bg-yellow-200" data-id="element-4">
      <SocialProofPopup data-id="element-5" />

      {/* SECTION 1 - URGENCY BAR */}
      <div className="sticky top-0 z-40 bg-red-600 text-white py-3 px-4 text-center font-bold text-sm md:text-base shadow-md flex flex-col md:flex-row items-center justify-center gap-2" data-id="element-6">
        <div className="flex items-center gap-2" data-id="element-7">
          <span data-id="element-8">⏳ OFERTA EXPIRA EN:</span>
          <div className="bg-white text-red-600 px-2 py-1 rounded shadow-inner" data-id="element-9">
            <CountdownTimer data-id="element-10" />
          </div>
        </div>
        <span className="hidden md:inline" data-id="element-11">|</span>
        <span className="flex items-center gap-1" data-id="element-12">🔥 CUPOS LIMITADOS</span>
      </div>

      <main className="max-w-4xl mx-auto" data-id="element-13">
        {/* SECTION 2 - HERO */}
        <section className="px-4 pt-10 pb-12 text-center" data-id="element-14">
          <div className="inline-block bg-yellow-100 text-yellow-800 px-4 py-2 rounded-full font-semibold text-sm md:text-base mb-6 border border-yellow-200" data-id="element-15">
            ☀️ Para gente común, emprendedores e instaladores que quieren
            aprender sin volverse ingenieros
          </div>

          <h1 className="text-4xl md:text-6xl font-black tracking-tight leading-tight mb-6 uppercase" data-id="element-16">
            🔧 APRENDÉ A INSTALAR{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-500 to-orange-500" data-id="element-17">
              PANELES SOLARES
            </span>
          </h1>

          <p className="text-xl md:text-2xl font-medium text-gray-700 mb-4 max-w-3xl mx-auto leading-relaxed" data-id="element-18">
            No es un curso: es una habilidad para cobrar instalaciones de USD
            2.000 a USD 3.000.
          </p>

          <p className="text-lg md:text-xl font-bold text-gray-900 mb-10 bg-gray-100 py-3 px-6 rounded-lg inline-block" data-id="element-19">
            Claro. Práctico. Paso a paso. Sin tecnicismos. Sin vueltas.
          </p>

          <motion.div whileHover={{
          scale: 1.02
        }} className="cursor-pointer mb-10 relative group max-w-2xl mx-auto" onClick={handleCheckoutClick} data-id="element-20">
            <div className="absolute inset-0 bg-yellow-400 rounded-2xl blur-xl opacity-20 group-hover:opacity-40 transition-opacity duration-300" data-id="element-21"></div>
            <img src="https://cdn.magicpatterns.com/uploads/cZtAUjFqb6WP8CTB3sfQtG/hf_20260305_201750_a813d54e-468c-483b-9609-a79fbd989001.jpg" alt="Pack de 14 Tomos Aprende a Instalar Paneles Solares" className="w-full h-auto rounded-2xl shadow-2xl relative z-10 border border-gray-200" data-id="element-22" />
          </motion.div>

          <CtaButton text="👉 SÍ, QUIERO ACCEDER AHORA" data-id="element-23" />

          <div className="mt-4 flex items-center justify-center gap-2 text-gray-600 font-medium" data-id="element-24">
            <ShieldCheckIcon className="w-5 h-5 text-green-500" data-id="element-25" />
            <span data-id="element-26">✅ Garantía de satisfacción de 7 días</span>
          </div>
        </section>

        {/* SECTION 3 - PAIN POINTS */}
        <section className="px-4 py-12 bg-gray-50 border-y border-gray-200" data-id="element-27">
          <div className="max-w-3xl mx-auto" data-id="element-28">
            <p className="text-xl md:text-2xl font-medium mb-8 text-center" data-id="element-29">
              Si te interesa la energía solar, dejame hacerte una pregunta
              honesta:
            </p>

            <h2 className="text-2xl md:text-3xl font-bold text-center mb-10 text-red-600" data-id="element-30">
              ¿Te pasa que querés instalar paneles… pero cuando empezás a
              investigar te llenás de dudas?
            </h2>

            <div className="space-y-6 text-lg text-gray-700 mb-10" data-id="element-31">
              <p data-id="element-32">
                No porque seas incapaz. No porque no te interese. Sino porque
                nadie te lo explicó simple y en orden.
              </p>

              <ul className="space-y-4 font-medium bg-white p-6 rounded-xl shadow-sm border border-gray-100" data-id="element-33">
                <li className="flex items-start gap-3" data-id="element-34">
                  <XCircleIcon className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-35" />
                  <span data-id="element-36">Ves videos… y terminás más confundido.</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-37">
                  <XCircleIcon className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-38" />
                  <span data-id="element-39">Leés guías… y parecen escritas para ingenieros.</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-40">
                  <XCircleIcon className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-41" />
                  <span data-id="element-42">Querés comprar… pero tenés miedo de comprar mal.</span>
                </li>
              </ul>
            </div>

            <div className="bg-blue-50 border-l-4 border-blue-500 p-6 rounded-r-xl" data-id="element-43">
              <p className="text-xl md:text-2xl font-bold italic text-blue-900" data-id="element-44">
                Y pensás: "Ojalá alguien me lo explique como para hacerlo yo."
              </p>
            </div>
          </div>
        </section>

        {/* SECTION 4 - PROBLEM */}
        <section className="px-4 py-16" data-id="element-45">
          <div className="max-w-3xl mx-auto" data-id="element-46">
            <h2 className="text-3xl md:text-4xl font-black text-center mb-8" data-id="element-47">
              Instalar paneles no debería sentirse así
            </h2>

            <p className="text-xl text-center mb-8" data-id="element-48">
              El problema que nadie dice en voz alta es este:
            </p>

            <div className="bg-black text-white p-6 rounded-xl mb-10 text-center transform -rotate-1 shadow-xl" data-id="element-49">
              <p className="text-2xl md:text-3xl font-bold" data-id="element-50">
                👉 No te falta ganas. Te falta un mapa claro.
              </p>
            </div>

            <p className="text-lg font-medium mb-6" data-id="element-51">
              Si estás en este mundo, seguro te pasa alguna de estas:
            </p>

            <ul className="space-y-4 mb-10 text-lg" data-id="element-52">
              {['No sabés qué comprar ni qué es lo realmente importante', 'No entendés cómo dimensionar según tu consumo', 'Tenés miedo de instalar mal y romper equipos', 'Sentís que sin un "técnico" no podés avanzar', 'Te abruma la info suelta y contradictoria'].map((item, i) => <li key={i} className="flex items-start gap-3 bg-gray-50 p-4 rounded-lg border border-gray-100" data-id="element-53">
                  <span className="text-red-500 font-bold mt-1" data-id="element-54">●</span>
                  <span className="font-medium" data-id="element-55">{item}</span>
                </li>)}
            </ul>

            <p className="text-xl font-bold text-center text-red-600 bg-red-50 py-4 rounded-lg" data-id="element-56">
              Lo peor no es la duda. Es la sensación de estar a un paso… y no
              poder avanzar.
            </p>
          </div>
        </section>

        {/* SECTION 5 - SOLUTION */}
        <section className="px-4 py-16 bg-gradient-to-b from-yellow-50 to-white border-t border-yellow-100" data-id="element-57">
          <div className="max-w-3xl mx-auto text-center" data-id="element-58">
            <div className="inline-block bg-green-100 text-green-800 px-6 py-2 rounded-full font-bold text-lg mb-6" data-id="element-59">
              ✅ LA SOLUCIÓN
            </div>

            <h2 className="text-4xl md:text-5xl font-black mb-8" data-id="element-60">
              APRENDÉ A INSTALAR PANELES SOLARES
            </h2>

            <p className="text-xl mb-10 text-gray-700" data-id="element-61">
              Un sistema armado para gente común, emprendedores e instaladores,
              que te guía paso a paso para:
            </p>

            <div className="grid gap-4 text-left mb-12" data-id="element-62">
              {['Entender cómo funciona un sistema fotovoltaico', 'Dimensionar correctamente según tu consumo', 'Instalar con orden y seguridad', 'Tomar decisiones con criterio (sin que te vendan cualquier cosa)'].map((item, i) => <div key={i} className="flex items-center gap-4 bg-white p-5 rounded-xl shadow-sm border border-yellow-200" data-id="element-63">
                  <div className="text-2xl" data-id="element-64">📌</div>
                  <span className="text-lg font-bold text-gray-800" data-id="element-65">
                    {item}
                  </span>
                </div>)}
            </div>

            <div className="bg-yellow-400 text-black p-6 rounded-xl font-bold text-xl md:text-2xl shadow-lg transform rotate-1" data-id="element-66">
              Abrís el material → seguís el paso a paso → aplicás.
              <div className="text-lg font-medium mt-2 opacity-80" data-id="element-67">
                Sin improvisar. Sin perder tiempo. Sin depender de otros.
              </div>
            </div>
          </div>
        </section>

        {/* SECTION 6 - WHAT'S INCLUDED */}
        <section className="px-4 py-16 bg-white" data-id="element-68">
          <div className="max-w-3xl mx-auto" data-id="element-69">
            <h2 className="text-3xl md:text-4xl font-black text-center mb-10 flex items-center justify-center gap-3" data-id="element-70">
              <span className="text-4xl" data-id="element-71">📘</span> ¿Qué incluye exactamente?
            </h2>

            <p className="text-xl font-bold text-center mb-8 text-blue-600 bg-blue-50 py-3 rounded-lg" data-id="element-72">
              Accedés a 14 TOMOS EN PDF organizados (teoría + práctica +
              instalación):
            </p>

            <div className="flex flex-col md:flex-row items-center gap-8 mb-12" data-id="element-73">
              <div className="w-full md:w-1/2" data-id="element-74">
                <img src="https://cdn.magicpatterns.com/uploads/mcoGqmKa7ZZo4NUPuokhAb/hf_20260305_201354_9d7ecc84-e2cd-4d7b-8f4b-d9326f5c2b8a.png" alt="14 Tomos en PDF" className="w-full h-auto drop-shadow-2xl" data-id="element-75" />
              </div>

              <div className="w-full md:w-1/2 grid gap-3" data-id="element-76">
                {['Tomo 1: Manual de Energías Renovables', 'Tomo 2: Manual técnico para instalaciones domiciliarias', 'Tomo 3: Manual de instalación sistemas fotovoltaicos', 'Tomo 4: Seminario: intervenciones urbanas con energía solar', 'Tomo 5: Teoría: funcionamiento y componentes', 'Tomo 6: Sistemas fotovoltaicos domésticos conectados a la red eléctrica', 'Tomo 7: Generación de energía eléctrica en Argentina', 'Tomo 8: Integración de la energía solar en la arquitectura', 'Tomo 9: Formación: instalador de paneles', 'Tomo 10: Proyecto: caso real', 'Tomo 11: Manual de instalación Panasonic', 'Tomo 12: Infografías', 'Tomo 13: Manual práctico: instalación de paneles', 'Tomo 14: PANEL SOLAR'].map((item, i) => <div key={i} className="flex items-center gap-3 bg-gray-50 p-3 rounded-lg border-l-4 border-blue-500 hover:bg-blue-50 transition-colors text-sm md:text-base" data-id="element-77">
                    <span className="text-blue-500 flex-shrink-0" data-id="element-78">🔹</span>
                    <span className="font-bold text-gray-800" data-id="element-79">{item}</span>
                  </div>)}
              </div>
            </div>

            <CtaButton text="🚀 QUIERO EMPEZAR HOY MISMO - ACCEDER AL MEGAPACK" secondary data-id="element-80" />
          </div>
        </section>

        {/* SECTION 7 - BEFORE/AFTER */}
        <section className="px-4 py-16 bg-gray-900 text-white rounded-3xl mx-4 my-8 shadow-2xl" data-id="element-81">
          <div className="max-w-3xl mx-auto" data-id="element-82">
            <h2 className="text-3xl md:text-4xl font-black text-center mb-12 flex items-center justify-center gap-3" data-id="element-83">
              <span data-id="element-84">🔄</span> Antes vs Después
            </h2>

            <div className="grid md:grid-cols-2 gap-8" data-id="element-85">
              {/* Antes */}
              <div className="bg-red-950/40 p-8 rounded-2xl border border-red-900/50" data-id="element-86">
                <h3 className="text-2xl font-bold text-red-400 mb-6 flex items-center gap-2" data-id="element-87">
                  <XCircleIcon className="w-8 h-8" data-id="element-88" /> ❌ Antes
                </h3>
                <ul className="space-y-4" data-id="element-89">
                  {['Info suelta y contradictoria', 'Miedo a comprar mal', 'Dudas para dimensionar', 'Instalación improvisada', 'Dependencia de terceros'].map((item, i) => <li key={i} className="flex items-center gap-3 text-gray-300" data-id="element-90">
                      <span className="text-red-500" data-id="element-91">●</span> {item}
                    </li>)}
                </ul>
              </div>

              {/* Después */}
              <div className="bg-green-950/40 p-8 rounded-2xl border border-green-900/50 relative overflow-hidden" data-id="element-92">
                <div className="absolute top-0 right-0 w-32 h-32 bg-green-500/10 rounded-full blur-3xl" data-id="element-93"></div>
                <h3 className="text-2xl font-bold text-green-400 mb-6 flex items-center gap-2" data-id="element-94">
                  <CheckCircle2Icon className="w-8 h-8" data-id="element-95" /> ✅ Después
                </h3>
                <ul className="space-y-4 relative z-10" data-id="element-96">
                  {['Tenés un mapa completo', 'Comprás con criterio', 'Dimensionás con método', 'Instalás con orden', 'Avanzás con seguridad y confianza'].map((item, i) => <li key={i} className="flex items-center gap-3 text-white font-medium" data-id="element-97">
                      <span className="text-green-400" data-id="element-98">●</span> {item}
                    </li>)}
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* SECTION 8 - TESTIMONIALS */}
        <Testimonials data-id="element-99" />

        {/* SECTION 9 - OFFER/PRICING */}
        <section className="px-4 py-16 bg-black text-white" id="compra" data-id="element-100">
          <div className="max-w-2xl mx-auto text-center" data-id="element-101">
            <h2 className="text-3xl md:text-4xl font-black mb-10 text-yellow-400" data-id="element-102">
              📦 Lo que recibís hoy
            </h2>

            <div className="bg-gray-900 p-8 rounded-2xl border border-gray-800 mb-10 text-left" data-id="element-103">
              <ul className="space-y-4 text-xl font-medium" data-id="element-104">
                <li className="flex items-center gap-3" data-id="element-105">
                  <CheckCircle2Icon className="w-6 h-6 text-green-500" data-id="element-106" />
                  <span data-id="element-107">14 tomos en PDF (acceso inmediato)</span>
                </li>
                <li className="flex items-center gap-3" data-id="element-108">
                  <CheckCircle2Icon className="w-6 h-6 text-green-500" data-id="element-109" />
                  <span data-id="element-110">Descarga digital</span>
                </li>
                <li className="flex items-center gap-3" data-id="element-111">
                  <CheckCircle2Icon className="w-6 h-6 text-green-500" data-id="element-112" />
                  <span data-id="element-113">Acceso de por vida</span>
                </li>
                <li className="flex items-center gap-3" data-id="element-114">
                  <CheckCircle2Icon className="w-6 h-6 text-green-500" data-id="element-115" />
                  <span data-id="element-116">Garantía 7 días</span>
                </li>
              </ul>
            </div>

            <div className="mb-10" data-id="element-117">
              <p className="text-2xl text-gray-400 font-medium mb-2" data-id="element-118">
                Precio regular:{' '}
                <span className="line-through decoration-red-500 decoration-4" data-id="element-119">
                  ARS $59.990
                </span>
              </p>
              <div className="bg-red-600 inline-block px-8 py-4 rounded-xl transform -rotate-2 shadow-2xl border-2 border-red-400" data-id="element-120">
                <p className="text-4xl md:text-6xl font-black text-white" data-id="element-121">
                  🔥 HOY SOLO: ARS $19.990
                </p>
              </div>
            </div>

            <CtaButton text="👉 OBTENER EL MEGAPACK HOY" className="text-2xl md:text-3xl py-6" data-id="element-122" />

            <div className="mt-6 flex justify-center items-center gap-2" data-id="element-123">
              <ShieldCheckIcon className="w-5 h-5 text-green-400" data-id="element-124" />
              <span className="text-lg font-bold text-gray-300 tracking-wide" data-id="element-125">
                🔒 PAGO SEGURO POR MERCADO PAGO
              </span>
            </div>

            <div className="mt-6 flex justify-center gap-4" data-id="element-126">
              <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/5/5e/Visa_Inc._logo.svg/2560px-Visa_Inc._logo.svg.png" alt="Visa" className="h-8 bg-white p-1 rounded" data-id="element-127" />
              <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/2/2a/Mastercard-logo.svg/1280px-Mastercard-logo.svg.png" alt="Mastercard" className="h-8 bg-white p-1 rounded" data-id="element-128" />
              <img src="https://logotipoz.com/wp-content/uploads/2021/10/logo-mercado-pago.png" alt="Mercado Pago" className="h-8 bg-white p-1 rounded object-contain w-auto" data-id="element-129" />
            </div>
          </div>
        </section>

        {/* SECTION 10 - GUARANTEE */}
        <section className="px-4 py-16 bg-gray-50" data-id="element-130">
          <div className="max-w-2xl mx-auto bg-white p-8 md:p-12 rounded-3xl shadow-xl border-2 border-yellow-400 text-center relative" data-id="element-131">
            <div className="absolute -top-10 left-1/2 transform -translate-x-1/2 bg-yellow-400 rounded-full p-4 shadow-lg border-4 border-white" data-id="element-132">
              <ShieldCheckIcon className="w-12 h-12 text-black" data-id="element-133" />
            </div>

            <h2 className="text-3xl font-black mt-6 mb-6" data-id="element-134">
              🔒 Garantía sin riesgo
            </h2>

            <p className="text-xl text-gray-700 leading-relaxed font-medium" data-id="element-135">
              Probalo durante 7 días. Si no te aporta claridad real y un camino
              aplicable para avanzar, te devolvemos el 100%. Sin preguntas.
            </p>
          </div>
        </section>

        {/* SECTION 11 - FINAL CTA */}
        <section className="px-4 py-20 text-center bg-white" data-id="element-136">
          <div className="max-w-3xl mx-auto" data-id="element-137">
            <h2 className="text-4xl md:text-5xl font-black mb-8 text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-cyan-600" data-id="element-138">
              Cuidar tu energía puede ser más simple
            </h2>

            <p className="text-2xl font-medium text-gray-600 mb-4" data-id="element-139">
              No necesitás saberlo todo. Necesitás un sistema claro y ordenado.
            </p>

            <div className="bg-yellow-50 p-8 rounded-2xl mb-12 border border-yellow-200" data-id="element-140">
              <p className="text-2xl font-bold text-gray-900 mb-2" data-id="element-141">
                👉 Accedé ahora a "Aprendé a Instalar Paneles Solares"
              </p>
              <p className="text-xl text-gray-700 italic" data-id="element-142">
                Porque no se trata de "entender teoría"… Se trata de poder
                hacerlo. ☀️🔧
              </p>
            </div>

            <CtaButton text="👉 SÍ, QUIERO ACCEDER AHORA" className="mb-6" data-id="element-143" />

            <p className="text-sm text-gray-400 font-medium" data-id="element-144">
              Pagos 100% seguros y encriptados. Acceso inmediato tras la compra.
            </p>
          </div>
        </section>
      </main>

      {/* Global styles for animations */}
      <style dangerouslySetInnerHTML={{
      __html: `
        @keyframes pulse-slow {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.02); }
        }
        .animate-pulse-slow {
          animation: pulse-slow 3s ease-in-out infinite;
        }
      `
    }} data-id="element-145" />
    </div>;
}